import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  AddCircle,
  ArchiveTick,
  CloseCircle,
  Edit2,
  Eye,
  TickCircle,
  Trash,
} from "iconsax-react";
import { Link } from "react-router-dom";
import ReasonModal from "../ReasonModal";
import CustomPagination from "../../Utils/CustomPagination";
import LogModal from "./LogModal";
import Select from "react-select";

function List(props) {
  const [batchList, setBatchList] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const [selectedRow, setSelectedRow] = useState({});
  const [show, setShow] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showLogModal, setShowLogModal] = useState(false);
  const [currentLog, setCurrentLogs] = useState([]);
  const [isQCReject, setIsQCReject] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");
  const handleShowModal = useCallback(
    (title, text) => () => {
      setModalTitle(title);
      setModalText(text);
      setShowModal(true);
    },
    []
  );

  const [plantLocation, setPlantLocation] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [search, setSearch] = useState("");
  const [product, setProduct] = useState([]);
  const [productName, setProductName] = useState(null);
  const [batchNo, setBatchNo] = useState("");
  const [plantList, setPlantList] = useState([]);
  const [selectedRNDStatus, setSelectedRNDStatus] = useState("");
  const [selectedQCStatus, setSelectedQCStatus] = useState("");

  const rndStatusOptions = [
    { value: "", label: "All RND Status" },
    { value: "1", label: "Send for Approval" },
    { value: "2", label: "Approved" },
    { value: "3", label: "Rejected" },
  ];

  const qcStatusOptions = [
    { value: "", label: "All QC Status" },
    { value: "0", label: "Pending" },
    { value: "1", label: "Approved" },
    { value: "2", label: "Rejected" },
    { value: "3", label: "Correction" },
  ];

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };

  const columns = [
    {
      name: (
        <div>
          Product Name <br />
        </div>
      ),
      selector: (row) => `${row.product_name} - (${row.productCode}) - ${row?.size} ${row.unit?.toUpperCase() || ""}`.trim(),
      width: "280px",
    },
    {
      name: (
        <div>
          Batch No. <br />
        </div>
      ),
      selector: (row) => row.batch_no,
      width: "120px",
    },
    {
      name: (
        <div>
          Plant Location/Code <br />
        </div>
      ),
      selector: (row) => row.plant_name,
      width: "135px",
    },
    {
      name: (
        <div>
          Batch Size <br />
        </div>
      ),
      selector: (row) => row.batch_size,
    },
    {
      name: (
        <div>
          Bom Name <br />
        </div>
      ),
      selector: (row) => row.bom_name,
    },
    {
      name: (
        <div>
          Production Process Logs <br />
        </div>
      ),
      cell: (row) => (
        <>
          <RB.Button
            className="btn-flat me-1"
            title="View"
            onClick={handleLogView(row)}
          >
            <Eye />
          </RB.Button>
        </>
      ),
    },
    {
      name: (
        <div>
          Qc Remark <br />
        </div>
      ),
      selector: (row) => row.qc_result_remark,
      cell: (row) => {
        const wordCount = row.qc_result_remark?.split(" ").length;
        return wordCount > 2 ? (
          <RB.Button
            className="btn btn-flat"
            onClick={handleShowModal("Qc Remark", row.qc_result_remark)}
          >
            <Eye />
          </RB.Button>
        ) : (
          <span>{row.qc_result_remark}</span>
        );
      },
    },
    {
      name: (
        <div>
          R & D Status
          <br />
        </div>
      ),
      selector: (row) => {
        switch (row.RND_or_process_status) {
          case "1":
            return "Send for Approval";
          case "2":
            return "Approved";
          case "3":
            return "Rejected";
          default:
            return "-";
        }
      },
      width: "150px",
    },
    {
      name: (
        <div>
          QC Status
          <br />
        </div>
      ),
      selector: (row) => {
        switch (row.qc_status) {
          case "0":
            return "Pending";
          case "1":
            return "Approved";
          case "2":
            return "Rejected";
          case "3":
            return "Correction";
          default:
            return "-";
        }
      },
    },
    // {
    //   name: (
    //     <div>
    //       Date <br />
    //     </div>
    //   ),
    //   selector: (row) => moment(row.createdAt).format("DD-MM-YYYY hh:mm A"),
    // },
    {
      name: (
        <div>
          Action <br />
        </div>
      ),
      center: true,
      cell: (row) => (
        <>
          <RB.Button
            className="btn-flat me-1"
            title="View"
            onClick={handleView(row)}
          >
            <Eye />
          </RB.Button>

          {utils.hasPermission(
            primaryMenuRes,
            "Production Process",
            "production_process.edit"
          ) && (
            <>
              {(row?.qc_status == "3" || row?.qc_status == "0") && (
                <RB.Button
                  className="btn-flat me-1"
                  title="Edit"
                  onClick={handelEdit(row)}
                >
                  <Edit2 />
                </RB.Button>
              )}
            </>
          )}
          {row.RND_or_process_status === "1" &&
            utils.hasPermission(
              primaryMenuRes,
              "Production Process",
              "production_process.R&D_approve"
            ) && (
              <RB.Button
                className="btn-flat me-1"
                title="Approve"
                onClick={handleApprove(row)}
              >
                <TickCircle />
              </RB.Button>
            )}
          {row.RND_or_process_status === "1" &&
            utils.hasPermission(
              primaryMenuRes,
              "Production Process",
              "production_process.R&D_reject"
            ) && (
              <RB.Button
                className="btn-flat me-1"
                title="Reject"
                onClick={handleReject(row)}
              >
                <CloseCircle />
              </RB.Button>
            )}
        </>
      ),
    },
  ];

  const handleLogView = useCallback((row) => async () => {
    setCurrentLogs(row.production_log);
    setShowLogModal(true);
  });

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleSpecification = useCallback((row) => async () => {
    const propdata = {
      mode: "QCSpecification",
      rowData: row,
    };
    props.onChange(propdata);
  });

  useEffect(() => {
    getProductionLIst();
  }, [page]);

  const getProductionLIst = () => {
    const params = new URLSearchParams();

    params.append("page", page);
    params.append("per_page", countPerPage);

    if (productName) params.append("product_id", productName);
    if (batchNo) params.append("batch_no", batchNo);
    if (plantLocation) params.append("plant_id", plantLocation);
    if (selectedQCStatus) params.append("qc_status", selectedQCStatus);
    if (selectedRNDStatus) params.append("rnd_status", selectedRNDStatus);

    utils
      .callAPI("get", `/production/process/list?${params.toString()}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setBatchList(res);
        } else {
          setBatchList([]);
        }
        setSearch("");
      })
      .catch((err) => {
        setBatchList([]);
        setSearch("");
      });
  };

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/production/process/delete?id=${row.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getProductionLIst();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleApprove = useCallback(
    (row) => async () => {
      var bodyFormData = new FormData();
      bodyFormData.append("process_id", row.id);
      bodyFormData.append("status", "2");
      bodyFormData.append("reject_reason", "");

      utils
        .callAPI("post", `/production/process/change-status`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            getProductionLIst();
          } else {
            getProductionLIst();
          }
        })
        .catch((err) => {
          getProductionLIst();
        });
    },
    []
  );

  const handleQCApprove = useCallback(
    (row) => async () => {
      var bodyFormData = new FormData();
      bodyFormData.append("process_id", row.id);
      bodyFormData.append("status", "1");
      bodyFormData.append("reject_reason", "");

      utils
        .callAPI("post", `/production/process/change-status-qc`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            getProductionLIst();
          } else {
            getProductionLIst();
          }
        })
        .catch((err) => {
          getProductionLIst();
        });
    },
    []
  );

  const handleReject = useCallback(
    (row) => () => {
      setSelectedRow(row);
      handleShow();
    },
    []
  );

  const handleQCReject = useCallback(
    (row) => () => {
      setIsQCReject(true);
      setSelectedRow(row);
      handleShow();
    },
    []
  );

  useEffect(() => {
    getproduct();
    getPlantList();
  }, []);

  const getPlantList = () => {
    utils
      .callAPI("get", "/purchaseorder/plant/list")
      .then((res) => {
        if (typeof res !== "undefined") {
          setPlantList(res?.result);
        } else {
          setPlantList([]);
        }
      })
      .catch(() => {
        setPlantList([]);
      });
  };
  const getproduct = () => {
    utils
      .callAPI("get", `/Product/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setProduct(res?.result);
        } else {
          setProduct([]);
        }
      })
      .catch((err) => {
        setProduct([]);
      });
  };

  const submitRejection = async () => {
    if (isQCReject) {
      var bodyFormData = new FormData();
      bodyFormData.append("process_id", selectedRow.id);
      bodyFormData.append("status", "2");
      bodyFormData.append("reject_reason", rejectReason);

      utils
        .callAPI("post", `/production/process/change-status-qc`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            getProductionLIst();
            handleClose();
            setRejectReason("");
            setIsQCReject(false);
          } else {
            getProductionLIst();
          }
        })
        .catch((err) => {
          getProductionLIst();
        });
    } else {
      var bodyFormData = new FormData();
      bodyFormData.append("process_id", selectedRow.id);
      bodyFormData.append("status", "3");
      bodyFormData.append("reject_reason", rejectReason);

      utils
        .callAPI("post", `/production/process/change-status`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            getProductionLIst();
            handleClose();
            setRejectReason("");
          } else {
            getProductionLIst();
          }
        })
        .catch((err) => {
          getProductionLIst();
        });
    }
  };

  const handleSearch = () => {
    setPage(1);
    setSearch("search");
  };

  const handleReset = () => {
    setBatchNo("");
    setPlantLocation("");
    setDateRange([null, null]);
    setSelectedRNDStatus("");
    setSelectedQCStatus("");
    setPage(1);
    setProductName(null);
    setSearch("reset");
  };

  useEffect(() => {
    if (search == "search" || search == "reset") {
      getProductionLIst();
    }
  }, [search]);

  const productOptions = product.map((p) => ({
    value: p.id,
    label: p.productCode
      ? `${p.product_name} - (${p.productCode}) - ${p?.size} ${p?.unit?.toUpperCase() || ""}`
      : p.product_name,
  }));

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow ">
          <RB.Card.Header>
            <div className="floating-btns-holder-artisan"></div>
          </RB.Card.Header>
          <RB.Card.Body>
            {utils.hasPermission(
              primaryMenuRes,
              "Production Process",
              "production_process.view"
            ) && (
              <>
                <RB.Row className="mb-3">
                  <RB.Col md={3} className="mt-2">
                    <Select
                      options={productOptions}
                      value={
                        productName
                          ? productOptions.find(
                              (opt) => opt.value === productName
                            )
                          : null
                      }
                      onChange={(selectedOption) =>
                        setProductName(
                          selectedOption ? selectedOption.value : null
                        )
                      }
                      placeholder="Select Product Name"
                      isSearchable
                      isClearable
                    />
                  </RB.Col>
                  <RB.Col md={3} className="mt-2">
                    <RB.Form.Control
                      type="text"
                      placeholder="Batch No"
                      value={batchNo}
                      onChange={(e) => setBatchNo(e.target.value)}
                    />
                  </RB.Col>
                  <RB.Col md={3} className="mt-2">
                    <RB.Form.Select
                      value={plantLocation}
                      onChange={(e) => setPlantLocation(e.target.value)}
                    >
                      <option value="">Plant Location</option>
                      {plantList.map((plant) => (
                        <option key={plant.id} value={plant.id}>
                          {plant.plant_name}
                        </option>
                      ))}
                    </RB.Form.Select>
                  </RB.Col>
                  <RB.Col md={3} className="mt-2">
                    <RB.Form.Select
                      value={selectedQCStatus}
                      onChange={(e) => setSelectedQCStatus(e.target.value)}
                    >
                      {qcStatusOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </RB.Form.Select>
                  </RB.Col>
                  <RB.Col md={3} className="mt-2">
                    <RB.Form.Select
                      value={selectedRNDStatus}
                      onChange={(e) => setSelectedRNDStatus(e.target.value)}
                    >
                      {rndStatusOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </RB.Form.Select>
                  </RB.Col>

                  <RB.Col md="3" className="mt-2">
                    <RB.Button
                      variant="primary"
                      className="me-2"
                      onClick={handleSearch}
                    >
                      Search
                    </RB.Button>
                    <RB.Button variant="secondary" onClick={handleReset}>
                      Reset
                    </RB.Button>
                  </RB.Col>
                </RB.Row>
                <DataTable
                  columns={columns}
                  data={batchList.result}
                  highlightOnHover
                  responsive
                  pagination
                  paginationServer
                  paginationTotalRows={batchList.total}
                  paginationPerPage={countPerPage}
                  paginationComponentOptions={{
                    noRowsPerPage: true,
                  }}
                  paginationComponent={() => (
                    <CustomPagination
                      currentPage={page}
                      totalRows={batchList.total}
                      rowsPerPage={countPerPage}
                      onPageChange={handlePageChange}
                    />
                  )}
                  onChangePage={(page) => setPage(page)}
                  persistTableHead
                  customStyles={{
                    head: {
                      style: {
                        fontSize: "0.875rem", // Adjust the font size as needed
                        fontWeight: "bold", // Adjust the font weight as needed
                      },
                    },
                  }}
                  striped
                />
              </>
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
      <RB.Modal show={show} onHide={handleClose}>
        <RB.Modal.Header closeButton>
          <RB.Modal.Title>Rejection Reason</RB.Modal.Title>
        </RB.Modal.Header>
        <RB.Modal.Body>
          <RB.Form.Group controlId="rejectReason">
            {/* <RB.Form.Label>Please enter the rejection reason:</RB.Form.Label> */}
            <RB.Form.Control
              as="textarea"
              rows={3}
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Enter reason for rejection..."
            />
          </RB.Form.Group>
        </RB.Modal.Body>
        <RB.Modal.Footer>
          <RB.Button variant="secondary" onClick={handleClose}>
            Close
          </RB.Button>
          <RB.Button
            variant="primary"
            onClick={submitRejection}
            disabled={!rejectReason}
          >
            Reject
          </RB.Button>
        </RB.Modal.Footer>
      </RB.Modal>
      <LogModal
        show={showLogModal}
        onHide={() => setShowLogModal(false)}
        logs={currentLog}
      />
      <ReasonModal
        show={showModal}
        onHide={() => setShowModal(false)}
        title={modalTitle}
        text={modalText}
      />
    </>
  );
}

export default List;
